<template>
  <section class="main-content bg-light " v-if="jobPost">
    <div class="row">
      <div class="col-lg-6 offset-lg-3 col-12 p-0">
        <!-- Navigation -->
        <div class="p-3">
          <router-link class="btn btn-outline-info" to="/job-posts">
            <i class="fal fa-home-alt"></i> หน้ารวมงาน
          </router-link>
        </div>

        <!-- Job Post Detail -->
        <section class="bg-white p-3">
          <div class="d-flex text-secondary text-small">
            <div class="flex-fill">
              Job #{{ jobPost.code }}
            </div>
            <div class="flex-fill text-right">
              {{ jobPost.created_at | prettyDate }}
            </div>
          </div>
          <div class="py-3 text-center">
            <div class="job-post-title">{{ jobPost.title }}</div>
            <div class="job-post-salary -status-alert mt-2"> {{ jobPost.min_salary | currency }} - {{ jobPost.max_salary
              | currency }} / เดือน
            </div>
            <div class="mt-4">
              <i class="fas fa-map-marker-alt -status-alert"></i> {{ jobPost.address_province | multiLangName }} - {{
              jobPost.district | multiLangName }}
            </div>
            <div class="mt-2" v-if="jobPost.job_users.length > 0">
              <i class="fas fa-user"></i> มี {{ jobPost.job_users.length }} คนสนใจ
            </div>
          </div>
        </section>

        <section class="bg-white p-3 mt-3">
          <h3>สวัสดิการ</h3>
          <div>
            <div><label>ที่พัก</label></div>
            {{ (jobPost.has_accommodation === 0) ? 'ไม่มีที่พักให้ (ไป-กลับ)' : 'มีที่พักให้' }}
          </div>
          <div class="mt-3" v-if="jobPost.job_post_welfares.length > 0">
            <div><label>สวัสดิการอื่น ๆ</label></div>
            <ul class="pl-4">
              <li v-for="item, index in jobPost.job_post_welfares">
                {{ item.job_welfare.name }}
              </li>
            </ul>
          </div>
        </section>

        <section class="bg-white p-3 mt-3">
          <h3>คุณสมบัติ</h3>
          <div class="mt-3" v-if="jobPost.job_post_skills.length > 0">
            <div><label>ทักษะที่ต้องการ</label></div>
            <ul class="pl-4">
              <li v-for="item, index in jobPost.job_post_skills">
                {{ item.job_skill.name }}
              </li>
            </ul>
          </div>
          <div class="mt-3" v-if="jobPost.job_post_languages.length > 0">
            <div><label>ภาษา</label></div>
            <ul class="pl-4 mb-0">
              <li v-for="item, index in jobPost.job_post_languages">
                {{ item.language.name }}
              </li>
            </ul>
          </div>
        </section>

        <section class="bg-white p-3 mt-3">
          <h3>รายละเอียดงาน</h3>
          <div v-html="handleNewLine(jobPost.description)" v-linkified></div>
        </section>
      </div>
    </div>
    <div class="bg-white bottom-button border-top p-2" v-if="jobUser">
      <button class="btn btn-lg btn-outline-secondary btn-block p-2"
              v-if="!isInterestedJob(jobPost)"
              @click="addData()">
        <i class="fas fa-plus"></i> สนใจรับงานนี้
      </button>
      <button class="btn btn-lg btn-info btn-block p-2"
              v-else
              @click="deleteData()">
        <i class="fas fa-check"></i> ลงชื่อสนใจรับงานนี้แล้ว
      </button>
    </div>
  </section>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    data () {
      return {
        id: this.$route.params.id,
        saved: false
      }
    },
    computed: {
      ...mapState('jobPost', ['jobPost']),
      ...mapState('jobUser', ['jobUser'])
    },
    methods: {
      ...mapActions('jobPost', ['fetchJobPostDetail']),
      ...mapActions('jobUser', ['addJobUserJobPost', 'deleteJobUserJobPost']),
      handleNewLine (str) {
        return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
      },
      isInterestedJob (jobPost) {
        let result = false
        const jobUsers = jobPost.job_users
        if (jobUsers && jobUsers.length > 0) {
          for (let item of jobUsers) {
            if (this.jobUser.id === item.job_user_id) {
              result = true
              break
            }
          }
        }
        return result
      },
      async addData () {
        const submitData = {
          job_post_id: this.jobPost.id,
          job_user_id: this.jobUser.id
        }
        await this.addJobUserJobPost(submitData)
        this.fetchJobPostDetail(this.id)
      },
      async deleteData () {
        const submitData = {
          job_post_id: this.jobPost.id,
          job_user_id: this.jobUser.id
        }
        await this.deleteJobUserJobPost(submitData)
        this.fetchJobPostDetail(this.id)
      }
    },
    mounted () {
      this.fetchJobPostDetail(this.id)
    }
  }
</script>

<style scoped>
  .main-content {
    padding-bottom: 5rem;
  }

  .bottom-button {
    z-index: 10;
    height: auto;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .menu-text {
    color: #00ACC1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/jobPost/JobPostDetail.vue